import { Box, Button, Checkbox, TableCell, TableRow, TextField } from '@mui/material'
import React from 'react'

const StockHistoryModalTableItem = ({ row, isEditMode, selectedProducts, handleChangeCogs, handleChangeQuantity, setSelectedProducts }) => {
  // console.log(row);

  
  return (
    <TableRow>
      <TableCell sx={{
        width: '26px',
      }}>
        <Checkbox color={"success"} sx={{ width: '26px', height: '26px'}}
          defaultValue={row?.id}
        />
      </TableCell>
      <TableCell scope='row' sx={{ width: '30px', height: '30px' }}>
        <img src={row?.img} style={{ width: '30px', height: '30px' }} />
      </TableCell>    
      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '130px', height: '30px'}} title={row?.name}>
        {row?.name}
      </TableCell>
      <TableCell sx={{ width: '75px', textAlign: 'center', height: '30px'}}>
        {!isEditMode ? row?.quantity :
          <input
            id="outlined-number"
            type="number"
            value={row?.quantity}
            onChange={(e) => {handleChangeQuantity(row.sku, parseFloat(parseFloat(e.target.value)))}}
            min={0}
          />
        }
      </TableCell>
      <TableCell sx={{ width: '75px', textAlign: 'center', height: '30px'}}>
        {!isEditMode ? row?.ourPrice :
          <input
            id="outlined-number"
            type="number"
            value={row?.ourPrice}
            onChange={(e) => {handleChangeCogs(row.sku, parseFloat(parseFloat(e.target.value)))}}
            min={0}
          />
        }
      </TableCell>
      <TableCell sx={{ width: '75px', textAlign: 'center', height: '30px', borderRadius: '7px'}}>
        {row?.IVA ? row.IVA : 0}%
      </TableCell>
      <TableCell sx={{ width: '75px', textAlign: 'center', height: '30px', backgroundColor: row?.status?.color, color: '#fff !important', borderRadius: '7px'}}>
        {row?.status ? row.status.name : 'N/A'}
      </TableCell>
      <TableCell sx={{ width: '75px', textAlign: 'center', height: '30px'}}>
        {(row?.quantity && row?.ourPrice ? row.quantity * row.ourPrice : 0).toFixed(2)}€
      </TableCell>
    </TableRow>
  )
}

export default StockHistoryModalTableItem